import React, { useState, useEffect } from 'react';
import { FaCommentDots, FaWhatsapp, FaTimes } from 'react-icons/fa';
import './CustomerSupport.css';

const CustomerSupport = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [hasModalOpen, setHasModalOpen] = useState(false);
  const supportPhone = '255747636516'; // Whatapp number wa HarusiOnline, au msaidizi

  useEffect(() => {
    const isElementVisible = (el) => {
      if (!el) return false;
      const style = window.getComputedStyle(el);
      return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        style.opacity !== '0' &&
        el.offsetWidth > 0 &&
        el.offsetHeight > 0
      );
    };

    const checkIfModalOpen = () => {
      // 1. Check body classes
      const isBodyModalOpen =
        document.body.classList.contains('modal-open') ||
        document.body.classList.contains('hide-customer-support');

      if (isBodyModalOpen) {
        setIsOpen(false);
        setHasModalOpen(true);
        return;
      }

      // 2. Check for any backdrop
      const backdrop = document.querySelector('.modal-backdrop, .modal-overlay');
      if (backdrop && isElementVisible(backdrop)) {
        setIsOpen(false);
        setHasModalOpen(true);
        return;
      }

      // 3. Check for any active/visible modal dialog or content
      const modals = document.querySelectorAll(
        '.modal-dialog, .modal-content, .modal.show, .modal-overlay, div[role="dialog"]'
      );
      for (let i = 0; i < modals.length; i++) {
        const el = modals[i];
        if (el.classList.contains('show') || isElementVisible(el)) {
          setIsOpen(false);
          setHasModalOpen(true);
          return;
        }
      }

      setHasModalOpen(false);
    };

    checkIfModalOpen();

    // Observe all DOM mutations without restricting attributeFilter
    const observer = new MutationObserver(() => {
      checkIfModalOpen();
    });

    observer.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true
    });

    // Fast interval fallback check every 250ms
    const timer = setInterval(checkIfModalOpen, 250);

    return () => {
      observer.disconnect();
      clearInterval(timer);
    };
  }, []);

  const toggleSupport = () => {
    setIsOpen(!isOpen);
  };

  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${supportPhone}?text=Habari, nahitaji msaada kuhusu HarusiOnline`, '_blank');
    setIsOpen(false);
  };

  if (hasModalOpen) {
    return null;
  }

  return (
    <div className="customer-support-widget">
      {isOpen && (
        <div className="support-menu fade-in-up">
          <div className="support-header">
            <h6 className="mb-0 fw-bold text-white">HarusiOnline Support</h6>
            <button className="close-btn-support" onClick={toggleSupport}>
              <FaTimes />
            </button>
          </div>
          <div className="support-body">
            <p className="text-muted small mb-3">
              Karibu! Je, unahitaji msaada wowote au una swali kuhusu mfumo?
            </p>
            <button className="btn-whatsapp-support w-100" onClick={handleWhatsAppClick}>
              <FaWhatsapp className="me-2 fs-5" /> Wasiliana Nasi
            </button>
          </div>
        </div>
      )}

      <button
        className={`support-fab shadow-lg ${isOpen ? 'active' : ''}`}
        onClick={toggleSupport}
        title="Customer Support"
      >
        <FaCommentDots size={28} />
      </button>
    </div>
  );
};

export default CustomerSupport;
